<template>
  <div class="container">
    <div class="brand">
      <!-- 返回栏 -->
      <div>
        <nav-bar title="品牌"></nav-bar>
      </div>
      <div class="brand_list" ref="seriesBox" @scroll="onScroll">
        <van-index-bar :index-list="searchLetterList" highlight-color="#1989fa">
          <div v-for="(item, index) in searchLetterList" :key="index">
            <div v-if="item == '热'">
              <van-index-anchor class="brand_title" :index="item">热门新车</van-index-anchor>
              <div class="hot_brand">
                <van-grid :border="false" :column-num="4">
                  <van-grid-item class="brand_box" v-for="item in HotBrandList" :key="item.id" @click="bindBrand(item.id, item.name)">
                    <van-image :src="item.logoImg" class="brand_img" />
                    <span>{{ item.name }}</span>
                  </van-grid-item>
                </van-grid>
              </div>
            </div>
            <div v-else-if="item == '*'">
              <van-index-anchor class="brand_title" :index="item">*</van-index-anchor>
              <van-cell title="不限品牌" @click="bindBrand('不限', '不限品牌')" />
            </div>
            <div v-else>
              <van-index-anchor class="brand_title" :index="item">{{ item }}</van-index-anchor>
              <van-cell :title="itemA.name" v-for="itemA in brandList[item]" :key="itemA.id" @click="bindBrand(itemA.id, itemA.name)" />
            </div>
          </div>
        </van-index-bar>
      </div>
      <!-- 弹出车系 -->
      <transition name="van-slide-right">
        <div v-show="seriesPopupShow" class="series_box" @scroll.stop="">
          <!-- 首行 -->
          <div class="series_title">{{ brandName }}</div>
          <div>
            <van-cell v-for="item in seriesList" :key="item.id" @click="bindSeries(item.id, item.name)">{{ item.name }}</van-cell>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '车辆品牌',
      brand: '',
      series: '',
      brandName: '',
      seriesName: '',
      // 品牌相关
      searchLetterList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      brandList: {},
      HotBrandList: [],
      seriesPopupShow: false,
      seriesList: []
    }
  },
  created() {
    this.getBrandList()
    this.getHotBrandList()
  },
  methods: {
    // 品牌
    listBrand(brandArr) {
      var temp = {}
      this.searchLetterList.forEach(itemA => {
        temp[itemA] = []
        brandArr.forEach(item => {
          if (itemA == item.firstLetter) {
            temp[itemA].push(item)
          }
        })
      })
      return temp
    },
    async getHotBrandList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/hotBrands')
      if (data.success) {
        this.HotBrandList = data.data.list
      }
    },
    async getBrandList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listBrand')
      if (data.success) {
        this.brandList = this.listBrand(data.data.list)
        this.searchLetterList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        this.searchLetterList.unshift('*')
        this.searchLetterList.unshift('热')
      }
    },

    async getSeriesList(id) {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listSeries', {
        params: {
          brandId: id
        }
      })
      if (data.success) {
        this.seriesList = data.data.list
        this.seriesList.unshift({
          name: '不限车系',
          id: ''
        })
      }
    },

    // 选中品牌
    bindBrand(brand, brandName) {
      if (brand == '不限') {
        this.brand = 0
        this.brandName = ''
        this.series = 0
        this.seriesName = ''
        this.toBuyCar()
      } else {
        this.brandName = brandName
        this.brand = brand
        this.getSeriesList(brand)
        this.seriesPopupShow = true
      }
    },

    bindSeries(id, name) {
      if (id == '') {
        this.seriesName = ''
        this.series = 0
      } else {
        this.seriesName = name
        this.series = id
      }

      this.toBuyCar()
      this.seriesPopupShow = false
    },
    onScroll() {
      this.seriesPopupShow = false
    },
    brandScroll() {
      this.seriesPopupShow = false
    },

    toBuyCar() {
      this.$router.push({
        path: '/buy-car',
        query: {
          brand: this.brand,
          series: this.series,
          brandName: this.brandName,
          seriesName: this.seriesName
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}
.brand_box {
  color: #757a7e;
  .brand_img {
    width: 0.45rem;
    height: 0.35rem;
  }
  div {
    width: 50px;
    padding-left: 5px;
  }
}
.brand_list {
  height: 7.5rem;
  overflow: scroll;
  position: fixed;
}
.series_box {
  position: fixed;
  z-index: 666;
  top: 46px;
  bottom: 0;
  left: 30%;
  width: 70%;
  background-color: #fff;
  box-shadow: -2px 0 2px 0 #ccc;
  overflow: scroll;
  padding-left: 10px;
  .series_title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
  }
}
</style>
